import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
@Component({
    selector: 'app-new-surrender-modal',
    templateUrl: './new-surrender-modal.component.html',
    styleUrls: ['./new-surrender-modal.component.scss'],
    standalone: true,
    imports: [MatButton, TranslateModule]
})
export class NewSurrenderModalComponent {
  dialogRef = inject<MatDialogRef<NewSurrenderModalComponent>>(MatDialogRef);



  onCancel() {
    this.dialogRef.close(false);
  }
  onProceed():void{
  this.dialogRef.close('true');
  }
}
